<ul class="mobile-links mobile-links--level--{{ level }}" appCollapse>
    <li *ngFor="let link of links">
        <div class="mobile-links__item" appCollapseItem="mobile-links__item--open" #item="appCollapseItem">
            <div class="mobile-links__item-title">
                <a class="mobile-links__item-link" (click)="onItemClick(link)"
                [routerLink]="type == 'category'? ((sector) ? ['/sector', sector] : ['/']).concat([type, link.seo?.slug]):['/sector', link.seo?.slug]">{{ translateHelper.localize(link.name) }}</a>
                <!-- <a *ngIf="link.type !== 'link'" class="mobile-links__item-link" (click)="onItemClick(link)">{{ link.label }}</a> -->
                <button *ngIf="link.subCategories" class="mobile-links__item-toggle" type="button"
                    (click)="item.toggle()">
                    <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                </button>
            </div>
            <div *ngIf="link.subCategories" class="mobile-links__item-sub-links" appCollapseContent>
                <app-mobile-links [type]="type" [links]="link.subCategories" [level]="0" (itemClick)="itemClick.emit($event)">
                </app-mobile-links>
            </div>
        </div>
        <!-- <div *ngIf="link.type === 'divider'" class="mobile-links__divider"></div> -->
    </li>
</ul>
